const css = `.aqbTMq__searchieChart{font-family:var(--typography-font-monospace);font-size:var(--typography-font-scale-body6);font-weight:var(--typography-fw-medium);position:relative}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"searchieChart":"aqbTMq__searchieChart"};
